import {
  AD_PREVIEW_SCROLLING,
  AD_COMPARER_UPDATE_ACCORDION_INDEX,
  AD_PREVIEW_UPDATE_ALL,
  AD_PREVIEW_SELECT_CAMPAIGNS,
  AD_PREVIEW_INDETERMINATE_CAMPAIGNS,
  AD_PREVIEW_SELECT_ADS,
  AD_PREVIEW_DISPLAY_CHECKBOX,
  AD_PREVIEW_DISPLAY_COPY_BUTTONS,
  AD_PREVIEW_COMPARE_MOBILE_DESKTOP,
  AD_PREVIEW_UPDATE_ACCORDION_INDEX,
  AD_PREVIEW_EXPAND_ALL,
  AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC
} from '../constants/ActionTypes';

export function adPreviewScrolling(isScrolling) {
  return { type: AD_PREVIEW_SCROLLING, isScrolling };
}

export function updateAdPreviewData(
  selectedAds,
  checkedCampaigns,
  indeterminateCampaigns
) {
  return {
    type: AD_PREVIEW_UPDATE_ALL,
    selectedAds,
    checkedCampaigns,
    indeterminateCampaigns
  };
}
export function updateSelectedCustomCampaigns(selectedCampaigns) {
  return { type: AD_PREVIEW_SELECT_CAMPAIGNS, selectedCampaigns };
}

export function updateIsIndeterminate(indeterminateCampaigns) {
  return { type: AD_PREVIEW_INDETERMINATE_CAMPAIGNS, indeterminateCampaigns };
}

export function updateSelectedCustomAds(selectedAds) {
  return { type: AD_PREVIEW_SELECT_ADS, selectedAds };
}

export function displayCustomCheckbox() {
  return { type: AD_PREVIEW_DISPLAY_CHECKBOX };
}

export function displayMultiQcCheckbox() {
  return { type: AD_PREVIEW_DISPLAY_CHECKBOX_MULTIQC };
}

export function displayCopyButtons() {
  return { type: AD_PREVIEW_DISPLAY_COPY_BUTTONS };
}

export function compareMobileDesktop() {
  return { type: AD_PREVIEW_COMPARE_MOBILE_DESKTOP };
}

export function expandAll() {
  return { type: AD_PREVIEW_EXPAND_ALL };
}

export function adPreviewAdAccordionIndex(accordionIndex, campaignKey) {
  return {
    type: AD_PREVIEW_UPDATE_ACCORDION_INDEX,
    accordionIndex,
    campaignKey
  };
}

export function adComparerAdMoreInfoIndex(moreInfoIndex, parentAdId) {
  return {
    type: AD_COMPARER_UPDATE_ACCORDION_INDEX,
    moreInfoIndex,
    parentAdId
  };
}



// WEBPACK FOOTER //
// ./src/actions/AdPreviewActions.js